import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { mapFamilyApiError } from '~entities/family/lib/map-family-api-error';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const setFamilyBillingParent = async (args: {
  familyId: string;
  parentId: string;
}) => {
  const response = await baseAPI.patch(
    `/v2/families/${args.familyId}/billing-parent`,
    { parentId: args.parentId },
  );
  return response.data;
};

export const useSetFamilyBillingParent = (studentId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: setFamilyBillingParent,
    onSuccess: () => {
      toast.success('Billing contact updated');
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_BY_STUDENT],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_HUB],
      });
    },
    onError: (error: unknown) => {
      toast.error(mapFamilyApiError(error, 'Failed to update billing contact'));
    },
  });
};
